module.exports = __webpack_public_path__ + "img/scan-barcode.4c156954.svg";